import React, { Component } from "react";
import { connect } from 'react-redux';
import MarkdownIt from "markdown-it";
import markdownItModifyToken from "markdown-it-modify-token";
import "./tournament-dialog.css";

import constants from "../../../constants/constants";
import withStaticImages from "../../../services/utils/imageNameRetriever";
import { getRoomList } from "../../../modules/restore_together";
import { modifyToken } from "../../../services/utils/modifyToken";

import TournamentLeaderboard from "./tournament-leaderboard.js";
import RoomCard from "../online-room-list/room_card.js";

const mdParser = new MarkdownIt({ typographer: true, modifyToken });
mdParser.use(markdownItModifyToken);

class TournamentDialog extends Component {

    componentDidMount() {
        const { dispatch } = this.props;
        console.log("GETTING ROOM LIST!");
        dispatch(getRoomList());
    }

    checkIfHasHtmlTags(value) {
        return /<[a-z/][\s\S]*>/i.test(value);
    }

    playSingleGameTournament() {
        let { tournament_data, token } = this.props;

        let port = window.location.port;

        let platformURL = "https://" + window.location.hostname;

        if (port !== "") {
            platformURL += ":" + port;
        }

        let gameID = tournament_data.game_id;
        // we do not prepend domain name with a protocol outside of local host
        const playUrl = constants.getPlayContentUrl();
        let nextURL = new URL(playUrl.startsWith("http") ? playUrl : `https:${playUrl}`);
        nextURL.pathname = ('/play_game');
        nextURL.searchParams.append('single_game_id', gameID);
        nextURL.searchParams.append('tournament_mode', '1');
        nextURL.searchParams.append('auth', token);
        nextURL.searchParams.append('purl', platformURL); // do not URL encode
        window.location = nextURL.href;
    }

    displayRelevantRoom() {
        let { tournament_data, roomList, token } = this.props;
        if (tournament_data.multiplayer) {
            for (let index in roomList) {
                let currentRoom = roomList[index];
                if (currentRoom.game_name === tournament_data.game_name) {
                    return <RoomCard room_data={currentRoom} token={token} />;
                }
            }
        }
        else {
            const game_image = (tournament_data.game_image) ?
                tournament_data.game_image :
                `${tournament_data.game_name.toLowerCase().replaceAll(' ', '_')}.png`;
            return (
                <div className='single_game_tournament_play_button' onClick={this.playSingleGameTournament.bind(this)}>
                    <div className='single_game_tournament_play_text'>Play Now</div>
                    <img alt={`${tournament_data.game_name} icon`} src={require(`../../../static/assets/game_icons/${game_image}`)}></img>
                </div>
            );
        }

    }

    render() {
        let { tournament_data, show, hide_func, token } = this.props;

        //const
        var messageContent = "";
        if (tournament_data.info) {
            messageContent = this.checkIfHasHtmlTags(tournament_data.info) ? tournament_data.info : mdParser.render(tournament_data.info)
            console.log("messageContent: ");
            console.log(messageContent);
        }

        let active = tournament_data.active;

        if (show) {
            const logo_file_name = tournament_data.business_group_logo !== null ? tournament_data.business_group_logo : 'RESTORE-Logo.png';
            return (
                <div className='tournament_dialog_container'>
                    <div className='tournament_modal'>
                        <div className='tournament_dialog'>
                            <div className='tournament_dialog_close' onClick={hide_func}>X</div>
                            <div id='tournament_dialog_title'>{tournament_data.name} Leaderboard</div>
                            <div className='tournament_dialog_content'>
                                <div className='tournament_dialog_half_content white'>
                                    <TournamentLeaderboard tournament_data={tournament_data} token={token} />
                                </div>
                                <div className='tournament_dialog_half_content'>
                                    <div id='tournament_logo_container'>
                                        <img alt='tournament_business_group_logo' className='tournament_business_group_logo' src={this.props.getImage(logo_file_name)}></img>
                                    </div>
                                    <div id='tournament_info_container'>
                                        <div id='tournament_info' dangerouslySetInnerHTML={{ __html: messageContent }}></div>
                                    </div>
                                    {active && <div id='tournament_room_card_container'>
                                        {this.displayRelevantRoom()}
                                    </div>}

                                    {!active && <div id='tournament_ended_message'>This tournament has ended!</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        else {
            return "";
        }

    }
}

const withState = connect((state) => {
    const { restoreTogether, user } = state;
    return {
        roomList: restoreTogether.roomList,
        token: user.token
    }
})

export default withState(withStaticImages('business_group_logos', TournamentDialog));



// WEBPACK FOOTER //
// ./src/components/containers/tournaments/tournament-dialog.js